import { bindModal } from '../common/modals';

export function bind() {
  bindModal();
}



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-report/index.js